import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const NextArrow = ({ onClick }) => (
  <div className="slick-custom-arrow slick-next" onClick={onClick}>
    <FontAwesomeIcon icon={faChevronRight} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-custom-arrow slick-prev" onClick={onClick}>
    <FontAwesomeIcon icon={faChevronLeft} />
  </div>
);

const Section3 = ({ url }) => {
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    centerMode: true, // Add this property
    centerPadding: "0px", // Adjust the value as per your requirement
     nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  };

  return (
    <>
      <section className="team-section-3" id="team-section-3">
        <div
          className="team-container"
          data-aos="fade-in"
          data-aos-duration="1000"
        >
          <div className="team-title">
            <p>Leadership Team</p>
          </div>
          <div className="team-cards-row">
            <Slider {...settings}>
              {/* <div className="team-member">
                <div className="m-name">Mahnoor Tariq</div>
                <div className="m-designation">Creative Designer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Mahnoor.png"}
                    alt="Mahnoor Tariq"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Bilal Ikram</div>
                <div className="m-designation">Embedded System Engineer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Bilal.png"}
                    alt="Bilal Ikram"
                  />
                </div>
              </div> */}
              <div className="team-member">
                <div className="m-name">Mehboob Ur Rehman</div>
                <div className="m-designation">Digital Marketing Manager.</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Mehboob.png"}
                    alt="Mehboob Ur Rehman"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Zohaib Iqbal </div>
                <div className="m-designation">Marketing Manager</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Zohaib.png"}
                    alt="Zohaib Iqbal"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Muntaha Naveed </div>
                <div className="m-designation">Digital Marketing Executive</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Muntaha.png"}
                    alt="Muntaha Naveed"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Noah William</div>
                <div className="m-designation">Business Development Manager</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Noah.png"}
                    alt="Noah William"
                    style={{ width: "95%" }}
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Muhammad Sajeel</div>
                <div className="m-designation">Sr. Android Dev.</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Sajeel.png"}
                    alt="Muhammad Sajeel"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Umar Ashraf</div>
                <div className="m-designation">Sr. Software Engineer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Umer.png"}
                    alt="Umar Ashraf"
                  />
                </div>
              </div>
              {/* <div className="team-member">
                <div className="m-name">Moeez Ahmad Dar</div>
                <div className="m-designation">Sr. Web Dev.</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Moeez.png"}
                    alt="Moeez Ahmed"
                  />
                </div>
              </div> */}
              <div className="team-member">
                <div className="m-name">Naveed Akram</div>
                <div className="m-designation">Sr. Software Engineer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Naveed.png"}
                    alt="Naveed Akram"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Moiz Ahmad</div>
                <div className="m-designation">Jr. Web Dev.</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Moeez.jpeg"}
                    alt="Moiz Ahmad"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Fatika Amir</div>
                <div className="m-designation">Graphic Designer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Fatika.jpeg"}
                    alt="Fatika Amir"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Usama Khalid</div>
                <div className="m-designation">Graphic Designer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Usama.jpeg"}
                    alt="Usama Khalid"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Abdul Rehman</div>
                <div className="m-designation">Associate Software Engineer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/AbdulRehman.png"}
                    alt="Abdul Rehman"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Zoha Habib</div>
                <div className="m-designation">Associate Software Engineer</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Zoha.png"}
                    alt="Zoha Habib"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Nailah Syed</div>
                <div className="m-designation">Director</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Maam-Nailah.png"}
                    alt="Nailah Syed"
                  />
                </div>
              </div>
              <div className="team-member">
                <div className="m-name">Ziaullah Mughal</div>
                <div className="m-designation">Delivery Manager - Digital</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/Zia-sb.png"}
                    alt="Ziaullah Mughal"
                  />
                </div>
              </div>
              {/* <div className="team-member">
                <div className="m-name">Shayaan Viqar</div>
                <div className="m-designation">Marketing Manager</div>
                <div className="m-img">
                  <img loading="lazy"
                    src={url + "images/our-team/team-member-1.png"}
                    alt="Nailah Syed"
                  />
                </div>
              </div> */}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section3;
